module.exports = __webpack_public_path__ + "static/media/statsActive.0ad1ffc4.svg";